import React, { useRef, useState } from "react";
import { motion } from "framer-motion";
import { Play, Video as VideoIcon } from "lucide-react";
import { BRAND } from "@/lib/brand";

const VIDEO_URL =
  "https://customer-assets.emergentagent.com/job_plataforma-consultor/artifacts/e553fywo_WhatsApp%20Video%202026-07-03%20at%2009.49.27.mp4";

export default function VideoSection() {
  const videoRef = useRef(null);
  const [playing, setPlaying] = useState(false);

  const handlePlay = () => {
    const v = videoRef.current;
    if (!v) return;
    setPlaying(true);
    const p = v.play();
    if (p && typeof p.catch === "function") {
      p.catch(() => {});
    }
  };

  return (
    <section id="video" className="scroll-mt-nav bg-efory-ink text-white py-20 md:py-28 border-y border-white/10">
      <div className="max-w-5xl mx-auto px-6 md:px-8 text-center">
        <span className="inline-flex items-center gap-2 rounded-full border border-efory-blue/30 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.2em] text-efory-blue">
          <VideoIcon className="h-3.5 w-3.5" /> Apresentação
        </span>
        <h2 className="font-heading text-3xl sm:text-4xl font-extrabold tracking-tight mt-6">
          Conheça a EFORY <span className="text-efory-blue">em vídeo</span>
        </h2>
        <p className="mt-4 text-white/65 max-w-xl mx-auto">
          Assista à nossa apresentação e entenda como podemos acelerar o crescimento do seu negócio.
        </p>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          data-testid="presentation-video-wrapper"
          className="mt-10 relative aspect-video rounded-3xl overflow-hidden border border-white/10 bg-black group"
        >
          <video
            ref={videoRef}
            src={VIDEO_URL}
            controls={playing}
            playsInline
            preload="metadata"
            data-testid="presentation-video"
            className="absolute inset-0 h-full w-full object-cover bg-black"
          />

          {!playing && (
            <button
              type="button"
              onClick={handlePlay}
              data-testid="play-video-button"
              aria-label="Assistir apresentação"
              className="absolute inset-0 flex flex-col items-center justify-center bg-efory-ink cursor-pointer overflow-hidden"
            >
              <span className="absolute inset-0 bg-grid-dark opacity-40" />
              <span className="absolute inset-0 bg-gradient-to-tr from-efory-blue/20 via-transparent to-efory-blue/10" />
              <img
                src={BRAND.logo}
                alt="EFORY"
                className="relative h-14 md:h-20 object-contain mb-7 drop-shadow-[0_0_25px_rgba(0,102,255,0.35)]"
              />
              <span className="relative h-20 w-20 rounded-full bg-efory-blue flex items-center justify-center shadow-2xl shadow-efory-blue/40 transition-transform duration-300 group-hover:scale-110">
                <Play className="h-9 w-9 text-white fill-white ml-1" />
              </span>
              <span className="relative mt-5 text-white/85 text-sm font-medium uppercase tracking-[0.2em]">
                Assistir apresentação
              </span>
            </button>
          )}
        </motion.div>
        <p className="mt-4 text-xs text-white/40">
          Apresentação da EFORY com Bernardo Henriques.
        </p>
      </div>
    </section>
  );
}
